import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Button from '../Button'
import { PRIVATE_ROUTES } from '../../Routes/routes'

import i18next from 'i18next'

const CreateJobOfferSuccess = ({
  matchCount = 0,
  id = 0,
  navigate = () => {},
  isJuniorView = false,
}) => {
  const MySwal = withReactContent(Swal)

  return MySwal.fire({
    icon: 'success',
    html: (
      <div className="text-on-bg-primary">
        <h3 className="text-center text-on-bg-primary">
          {i18next?.t('your_offer_was_created_successfully')}
        </h3>
        <span className="text-center text-on-bg-primary">
          {i18next?.t('our_ai_tool_has_matched')} <strong>{matchCount}</strong>{' '}
          {i18next?.t('profiles_you_can_find_them_in_the_favorites_section')}
        </span>
        <div className="d-flex justify-content-center align-items-center text-on-bg-primary gap-3 mt-4">
          <Button
            className="btn-white border border-on-bg-primary p-3"
            onClick={() => {
              if (isJuniorView) {
                window.location.href = PRIVATE_ROUTES.create_job_offer_juniors
              } else {
                window.location.href = PRIVATE_ROUTES.create_job_offer
              }
            }}
          >
            {i18next?.t('create_another_offer')}
          </Button>
          <Button
            className="btn-bg-CTA-primary p-3 text-on-bg-primary"
            onClick={() => {
              navigate(`/process/0/${id}`)
              Swal.close()
            }}
          >
            {i18next?.t('go_to_favorites')}
          </Button>
        </div>
      </div>
    ),
    showConfirmButton: false,
    showCloseButton: true,
    showClass: {
      popup: 'swal2-show',
      backdrop: 'swal2-backdrop-show modal-custom-styles',
      icon: 'swal2-icon-show',
    },
  })
}

export default CreateJobOfferSuccess
